<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/178odvU/tc-custom/9781504057097.jpg?1728259407917" alt="This image is the cover for the book Collected Memoirs Volume One"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Collected Memoirs Volume One
      </h1>
      <p class="bookDescription body article font2">
        <b>Three memoirs about isolation, aging, and death from an author whose “private self is as intelligent and generous as her public persona” (<i>Publishers Weekly</i>).</b><br/><br/><i>Fifty Days of Solitude</i>: Faced with a rare opportunity to experiment with true solitude, Doris Grumbach decided to live in her coastal Maine home without speaking to anyone for fifty days. A New York Times Notable Book, the result is a “quiet, elegantly written” recollection about what it means to write, to be alone, and to come to terms with mortality (<i>Publishers Weekly</i>).<br/>  <br/><i>The Pleasure of Their Company</i>: As her eightieth birthday approaches, Doris Grumbach uses the event as an opportunity both to look backward and to grow. She weaves a delightful tapestry of “surprising and meaningful observations,” allowing readers a glimpse into her life and the characters that have peopled her nearly eight decades on Earth (<i>Library Journal</i>).<br/>  <br/><i>Extra Innings</i>: This New York Times Notable Book follows a year in Doris Grumbach’s life, beginning with the release of her memoir <i>Coming into the End Zone</i>, and revealing that she possesses as keen an eye in her seventies as she did when she wrote <i>The Spoil of Flowers </i>thirty years earlier. In this “clear, honest picture of her own old age,” Grumbach details each passing month with their trials and triumphs (<i>Library Journal</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Doris Grumbach
      </h2>
      
      <p class="authorDescription body article">Doris Grumbach, author of many novels and memoirs including&#160;<I>Fifty Days of Solitude</I>,<I> Life in a Day</I>,&#160;<I>The Ladies</I>, and&#160;<I>Chamber Music</I>,&#160;has been literary editor of&#160;the <I>New Republic</I>, a nonfiction columnist for the <I>New York Times Book Review</I>, a book reviewer for National Public Radio, and a bookseller in Washington, DC, and Maine. She lives in Philadelphia.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f69221a